import React, { useMemo } from 'react';
import Select from 'react-select';
import { useMasterData } from '../../utils/useMasterData';

function HandoverItemTypeDropdown({ onChangeDropdown, required, showTitle, value }) {
    const { options, loading, error } = useMasterData('handoverItemTypes');

    const selectedOption = useMemo(() => {
        if (!value) {
            return null;
        }
        return options.find((item) => item.label === value || item.value === value) || null;
    }, [options, value]);

    const handleChange = (option, actionMeta) => {
        if (onChangeDropdown) {
            onChangeDropdown(option, actionMeta);
        }
    };

    return (
        <div>
            {showTitle ? (
                <label className="form-label">
                    Handover Item Type{required === true ? <span style={{ color: 'red' }}>*</span> : ''}
                </label>
            ) : (
                ''
            )}
            <Select
                name="HandoverItemType"
                value={selectedOption}
                isClearable={true}
                isLoading={loading}
                isDisabled={loading}
                options={options || []}
                onChange={handleChange}
                placeholder={loading ? 'Loading types...' : 'Select handover item type'}
            />
            {error ? <div className="text-danger mt-1">Failed to load handover item types.</div> : null}
        </div>
    );
}

export default HandoverItemTypeDropdown;
